export function getFaxageEmail(fax: string | undefined) {
    if (!fax) return "";
    return fax.replace(/\D/g, "") + "@faxage.com";
}
